/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
// Extends From
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
// Ember Imports
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
// External Imports
import moment from 'moment';
// Internal Imports
import LogAdministered from 'linced-app/enums/medical/log-administered';
import LogType from 'linced-app/enums/medical/log-type';
import Reason from 'linced-app/enums/medical/reason';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { rollbackRecord } from '@linc-technologies/linced-common/utils/record-rollback';

export default class BatchStock extends Component {
  @service
  session;

  @service
  store;

  @service
  toaster;

  Reason = Reason;
  Jurisdiction = Jurisdiction;
  batch = null;
  medication = null;
  @tracked
  dialogOpen = false;
  @tracked
  reason = null;
  @tracked originalQuantity = 0;
  @tracked
  changedQuantity = 0;
  @tracked
  finalNewQuantity = 0;

  @tracked
  saveInProgress;

  // Computed
  @computed('batch.{isValid,quantity}', 'originalQuantity')
  get batchIsValid() {
    if (this.batch.quantity === this.originalQuantity) {
      return false;
    }
    return this.batch.get('isValid');
  }

  @computed('batch.quantity', 'originalQuantity')
  get reasonNeeded() {
    return this.batch.quantity < this.originalQuantity;
  }

  @action
  openDialog() {
    this.dialogOpen = true;
    this.originalQuantity = this.batch.quantity;
    this.finalNewQuantity = this.batch.quantity;
    this.changedQuantity = 0;
    this.reason = null;
  }

  @action
  closeDialog() {
    this.dialogOpen = false;
    this.originalQuantity = 0;
    this.changedQuantity = 0;
    this.finalNewQuantity = 0;
    this.reason = null;
    rollbackRecord(this.batch);
  }

  @action
  updateChangeBy(value) {
    let finalQty = this.originalQuantity + parseInt(value, 10);
    this.changedQuantity = value;
    this.finalNewQuantity = finalQty;
    this.batch.set('quantity', finalQty);
  }

  @action
  updateFinalQuantity(value) {
    let changeBy = parseInt(value, 10) - this.originalQuantity;
    this.changedQuantity = changeBy;
    this.finalNewQuantity = value;
    this.batch.set('quantity', value);
  }

  @action
  save() {
    this.saveInProgress = true;
    this.batch.set('medication', this.medication);
    this.batch
      .save()
      .then(() => {
        this.toaster.success('Batch saved successfully!');
        if (this.reasonNeeded) {
          let quantity = this.originalQuantity - this.batch.get('quantity');
          this.store
            .createRecord('medical/log', {
              schoolId: this.get('session.school'),
              logType: LogType.UPDATE,
              medication: this.medication,
              batch: this.batch,
              displayDate: moment().unix(),
              administeredBy: LogAdministered.STAFF,
              administeredByPerson: this.get('session.person'),
              administrationDetails:
                quantity + ' ' + this.medication.get('unitString'),
              reason: this.reason,
            })
            .save()
            .then(() => {
              this.toaster.success('Log saved successfully!');
            })
            .catch(() => {
              this.toaster.error('Log save failed!');
            });
        }
      })
      .catch(() => {
        this.toaster.error('Batch save failed!');
      })
      .finally(() => {
        this.saveInProgress = false;
        this.dialogOpen = false;
      });
  }

  @action
  setReason(reason) {
    this.reason = reason.value;
  }

  @action
  boop() {}
}
